module.exports = __webpack_public_path__ + "static/media/iphone-mockup-half.ae5352b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/iphone-mockup-half.png
// module id = 1504
// module chunks = 0